import React from 'react';
import { Box, BoxProps, styled, SxProps, Theme } from '@mui/material';
import colors from 'src/utils/colors';
import { IconLess } from 'src/components/SvgIcons';

interface StyledPillProps extends BoxProps {
  variant?: 'filled' | 'outlined';
  iconSx?: SxProps<Theme>;
  pillSx?: SxProps<Theme>;
  customIcon?: React.ReactNode;
}

interface ActionPillProps extends StyledPillProps {
  onRemovalClick?: () => void;
}

export const StyledPill = styled(Box)<StyledPillProps>(({ variant = 'outlined', pillSx = {}, iconSx = {} }) => ({
  borderRadius: '24px',
  backgroundColor: variant === 'filled' ? colors.lightOpaqueBlue : colors.opaqueGrey,
  padding: '4px 8px 4px 12px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: variant === 'filled' ? colors.darkBlue : '#546379',
  lineHeight: '20px',
  ...(pillSx as React.CSSProperties)
}));

export const ActionPill: React.FC<ActionPillProps> = ({
  variant,
  pillSx = {},
  iconSx = {},
  onRemovalClick = () => {},
  customIcon,
  children
}) => {
  return (
    <StyledPill variant={variant} pillSx={pillSx}>
      {children}
      {customIcon ? (
        customIcon
      ) : (
        <IconLess
          style={{
            height: 16,
            width: 16,
            color: variant === 'filled' ? colors.darkBlue : '#546379',
            ...(iconSx as React.CSSProperties)
          }}
          onClick={onRemovalClick}
        />
      )}
    </StyledPill>
  );
};
